import React, { Component } from 'react';
import Fecha from 'fecha';

import { Row, Col, Collapse } from 'react-bootstrap'

const marginRemove = {
    marginLeft: "0px",
    marginRight: "0px"
}

const titleStyle = {
    backgroundColor: "#004d99",
    color: "#fff",
    fontWeight: "bold",
    marginLeft: "0px",
    marginRight: "0px"
}

const padding = {
    padding: "15px",
    wordWrap: "break-word"
}

const noPadding = {
    padding: "0px",
    wordWrap: "break-word"
}

const leftClass = "col-lg-3 col-sm-3 col-4 border";
const rightClass = "col-lg-9 col-sm-9 col-8 border";
const sIdClass = "col-lg-1 col-sm-1 col-2 d-flex justify-content-center align-self-center";

export default class UsedCertificates extends Component {

    constructor(props) {
        super(props);
        this.state = {
            open: false,
        };
    }

    render() {
        return (
            <React.Fragment>
                <Row tabIndex="0" role="button" style={titleStyle} className="border-top" onClick={() => this.setState({ open: !this.state.open })} onKeyUp={this.props.handleKeyUp}>
                    <Col style={padding} className="col-lg-12 col-sm-12 col-12">
                        <Row style={marginRemove}>
                            <Col className="col-lg-11 col-sm-11 col-10">
                                <Row>
                                    <Col style={{ "paddingLeft": "5px" }} className="col-3">
                                        Certificate ID:
									</Col>
                                    <Col className="col-9">
                                        {this.props.data.id}
                                    </Col>
                                </Row>
                            </Col>
                            <Col className={sIdClass} style={{ "paddingRight": "0px" }}>
                                {this.state.open ?
                                    <i className="material-icons align-middle" aria-hidden="true">expand_less</i>
                                    :
                                    <i className="material-icons align-middle" aria-hidden="true">expand_more</i>
                                }
                            </Col>
                        </Row>
                    </Col>
                </Row>

                <Collapse in={this.state.open}>
                    <div>
                        <Row style={marginRemove}>
                            <Col style={padding} className={leftClass}>Subject Distinguished Name:</Col>
                            {this.props.data.subjectDistinguishedName.length == 0 ?
                                <Col style={padding} className={rightClass}>-</Col>
                                :
                                <Col style={noPadding} className={rightClass}>
                                    {this.props.data.subjectDistinguishedName.map((subjectDistinguishedName, i) => {
                                        return <React.Fragment key={i}>
                                            <Row style={marginRemove}>
                                                <Col style={padding} className={leftClass}>
                                                    Value:
                                                </Col>
                                                <Col style={padding} className={rightClass}>
                                                    {dataValue(subjectDistinguishedName.value)}
                                                </Col>
                                            </Row>
                                            <Row style={marginRemove}>
                                                <Col style={padding} className={leftClass}>
                                                    Format:
                                                </Col>
                                                <Col style={padding} className={rightClass}>
                                                    {dataValue(subjectDistinguishedName.format)}
                                                </Col>
                                            </Row>
                                        </React.Fragment>
                                    })}
                                </Col>
                            }
                        </Row>

                        <Row style={marginRemove}>
                            <Col style={padding} className={leftClass}>Issuer Distinguished Name:</Col>
                            {this.props.data.issuerDistinguishedName.length == 0 ?
                                <Col style={padding} className={rightClass}>-</Col>
                                :
                                <Col style={noPadding} className={rightClass}>
                                    {this.props.data.issuerDistinguishedName.map((issuerDistinguishedName, i) => {
                                        return <React.Fragment key={i}>
                                            <Row style={marginRemove}>
                                                <Col style={padding} className={leftClass}>
                                                    Value:
                                                </Col>
                                                <Col style={padding} className={rightClass}>
                                                    {dataValue(issuerDistinguishedName.value)}
                                                </Col>
                                            </Row>
                                            <Row style={marginRemove}>
                                                <Col style={padding} className={leftClass}>
                                                    Format:
                                                </Col>
                                                <Col style={padding} className={rightClass}>
                                                    {dataValue(issuerDistinguishedName.format)}
                                                </Col>
                                            </Row>
                                        </React.Fragment>
                                    })}
                                </Col>
                            }
                        </Row>
                        <Row style={marginRemove}>
                            <Col style={padding} className={leftClass}>Serial Number:</Col>
                            {this.props.serialNumbers.length == 0 ?
                                <Col style={padding} className={rightClass}>
                                    -
                                </Col>
                                :
                                <Col style={padding} className={rightClass}>
                                    {this.props.serialNumbers[this.props.index]}
                                </Col>
                            }
                        </Row>
                        <Row style={marginRemove}>
                            <Col style={padding} className={leftClass}>Common Name:</Col>
                            <Col style={padding} className={rightClass}>{dataValue(this.props.data.commonName)}</Col>
                        </Row>
                        <Row style={marginRemove}>
                            <Col style={padding} className={leftClass}>Locality:</Col>
                            <Col style={padding} className={rightClass}>{dataValue(this.props.data.locality)}</Col>
                        </Row>
                        <Row style={marginRemove}>
                            <Col style={padding} className={leftClass}>State:</Col>
                            <Col style={padding} className={rightClass}>{dataValue(this.props.data.state)}</Col>
                        </Row>
                        <Row style={marginRemove}>
                            <Col style={padding} className={leftClass}>Country Name:</Col>
                            <Col style={padding} className={rightClass}>{dataValue(this.props.data.countryName)}</Col>
                        </Row>
                        <Row style={marginRemove}>
                            <Col style={padding} className={leftClass}>Organization Name:</Col>
                            <Col style={padding} className={rightClass}>{dataValue(this.props.data.organizationName)}</Col>
                        </Row>
                        <Row style={marginRemove}>
                            <Col style={padding} className={leftClass}>Given Name:</Col>
                            <Col style={padding} className={rightClass}>{dataValue(this.props.data.givenName)}</Col>
                        </Row>
                        <Row style={marginRemove}>
                            <Col style={padding} className={leftClass}>Organizational Unit:</Col>
                            <Col style={padding} className={rightClass}>{dataValue(this.props.data.organizationalUnit)}</Col>
                        </Row>
                        <Row style={marginRemove}>
                            <Col style={padding} className={leftClass}>Surname:</Col>
                            <Col style={padding} className={rightClass}>{dataValue(this.props.data.surname)}</Col>
                        </Row>
                        <Row style={marginRemove}>
                            <Col style={padding} className={leftClass}>Pseudonym:</Col>
                            <Col style={padding} className={rightClass}>{dataValue(this.props.data.pseudonym)}</Col>
                        </Row>
                        <Row style={marginRemove}>
                            <Col style={padding} className={leftClass}>Email:</Col>
                            <Col style={padding} className={rightClass}>{dataValue(this.props.data.email)}</Col>
                        </Row>

                        <Row style={marginRemove}>
                            <Col style={padding} className={leftClass}>Authority Information Access Url</Col>
                            {this.props.data.authorityInformationAccessUrls.length == 0 ?
                                <Col style={padding} className={rightClass}>-</Col>
                                :
                                <Col style={noPadding} className={rightClass}>
                                    {this.props.data.authorityInformationAccessUrls.map((authorityInformationAccessUrls, i) => {
                                        return <React.Fragment key={i}>
                                            <Row style={marginRemove}>
                                                <Col style={padding} className="border">
                                                    {dataValue(authorityInformationAccessUrls)}
                                                </Col>
                                            </Row>
                                        </React.Fragment>
                                    })}
                                </Col>
                            }
                        </Row>

                        <Row style={marginRemove}>
                            <Col style={padding} className={leftClass}>
                                Digest Algo and Values:
                            </Col>
                            {this.props.data.digestAlgoAndValues.length == 0 ?
                                <Col style={padding} className={rightClass}>
                                    -
								</Col>
                                :
                                <Col className={rightClass} style={noPadding}>
                                    {this.props.data.digestAlgoAndValues.map((digestAlgoAndValues, i) => {
                                        return <React.Fragment key={i}>
                                            <Row style={marginRemove}>
                                                <Col style={padding} className={leftClass}>
                                                    Digest Method:
															</Col>
                                                <Col style={padding} className={rightClass}>
                                                    {dataValue(digestAlgoAndValues.digestMethod)}
                                                </Col>
                                            </Row>
                                            <Row style={marginRemove}>
                                                <Col style={padding} className={leftClass}>
                                                    Digest Value:
															</Col>
                                                <Col style={padding} className={rightClass}>
                                                    {dataValue(digestAlgoAndValues.digestValue)}
                                                </Col>
                                            </Row>
                                        </React.Fragment>
                                    })}
                                </Col>
                            }
                        </Row>

                        <Row style={marginRemove}>
                            <Col style={padding} className={leftClass}>
                                Not After:
												</Col>
                            <Col style={padding} className={rightClass}>
                                {this.props.data.notAfter == null ?
                                    "-"
                                    :
                                    Fecha.format(new Date(this.props.data.notAfter), 'DD.MM.YYYY. [at] HH:mm')
                                }
                            </Col>
                        </Row>
                        <Row style={marginRemove}>
                            <Col style={padding} className={leftClass}>
                                Not Before:
												</Col>
                            <Col style={padding} className={rightClass}>
                                {this.props.data.notBefore == null ?
                                    "-"
                                    :
                                    Fecha.format(new Date(this.props.data.notBefore), 'DD.MM.YYYY. [at] HH:mm')
                                }
                            </Col>
                        </Row>
                        <Row style={marginRemove}>
                            <Col style={padding} className={leftClass}>Public Key Size:</Col>
                            <Col style={padding} className={rightClass}>{dataValue(this.props.data.publicKeySize)}</Col>
                        </Row>
                        <Row style={marginRemove}>
                            <Col style={padding} className={leftClass}>Public Key Encryption Algo:</Col>
                            <Col style={padding} className={rightClass}>{dataValue(this.props.data.publicKeyEncryptionAlgo)}</Col>
                        </Row>

                        <Row style={marginRemove}>
                            <Col style={padding} className={leftClass}>Key Usage Bits:</Col>
                            {this.props.data.keyUsageBits.length == 0 ?
                                <Col style={padding} className={rightClass}>-</Col>
                                :
                                <Col style={noPadding} className={rightClass}>
                                    {this.props.data.keyUsageBits.map((keyUsageBits, i) => {
                                        return <React.Fragment key={i}>
                                            <Row style={marginRemove}>
                                                <Col style={padding} className="border">
                                                    {dataValue(keyUsageBits)}
                                                </Col>
                                            </Row>
                                        </React.Fragment>
                                    })}
                                </Col>
                            }
                        </Row>

                        <Row style={marginRemove}>
                            <Col style={padding} className={leftClass}>Extended Key Usage:</Col>
                            {this.props.data.extendedKeyUsages.length == 0 ?
                                <Col style={padding} className={rightClass}>-</Col>
                                :
                                <Col style={noPadding} className={rightClass}>
                                    {this.props.data.extendedKeyUsages.map((extendedKeyUsages, i) => {
                                        return <React.Fragment key={i}>
                                            <Row style={marginRemove}>
                                                <Col style={padding} className={leftClass}>
                                                    Value:
									        </Col>
                                                <Col style={padding} className={rightClass}>
                                                    {dataValue(extendedKeyUsages.value)}
                                                </Col>
                                            </Row>
                                            <Row style={marginRemove}>
                                                <Col style={padding} className={leftClass}>
                                                    Description:
									        </Col>
                                                <Col style={padding} className={rightClass}>
                                                    {dataValue(extendedKeyUsages.description)}
                                                </Col>
                                            </Row>
                                        </React.Fragment>
                                    })}
                                </Col>
                            }
                        </Row>

                        <Row style={marginRemove}>
                            <Col style={padding} className={leftClass}>ID Pkix Ocsp Check:</Col>
                            <Col style={padding} className={rightClass}>{dataValue(this.props.data.idPkixOcspNoCheck)}</Col>
                        </Row>

                        <Row style={marginRemove}>
                            <Col style={padding} className={leftClass}>Basic Signature</Col>
                            {this.props.data.basicSignature == null ?
                                <Col style={padding} className={rightClass}>-</Col>
                                :
                                <Col className={rightClass} style={noPadding}>
                                    <Row style={marginRemove}>
                                        <Col style={padding} className={leftClass}>
                                            Encryption Algo Used To Sign This Token:
									</Col>
                                        <Col style={padding} className={rightClass}>
                                            {dataValue(this.props.data.basicSignature.encryptionAlgoUsedToSignThisToken)}
                                        </Col>
                                    </Row>
                                    <Row style={marginRemove}>
                                        <Col style={padding} className={leftClass}>
                                            Key Length Used To Sign This Token:
									</Col>
                                        <Col style={padding} className={rightClass}>
                                            {dataValue(this.props.data.basicSignature.keyLengthUsedToSignThisToken)}
                                        </Col>
                                    </Row>
                                    <Row style={marginRemove}>
                                        <Col style={padding} className={leftClass}>
                                            Digest Algo Used To Sign This Token:
									</Col>
                                        <Col style={padding} className={rightClass}>
                                            {dataValue(this.props.data.basicSignature.digestAlgoUsedToSignThisToken)}
                                        </Col>
                                    </Row>
                                    <Row style={marginRemove}>
                                        <Col style={padding} className={leftClass}>
                                            Mask Generation Function Used To Sign This Token
									</Col>
                                        <Col style={padding} className={rightClass}>
                                            {dataValue(this.props.data.basicSignature.maskGenerationFunctionUsedToSignThisToken)}
                                        </Col>
                                    </Row>
                                    <Row style={marginRemove}>
                                        <Col style={padding} className={leftClass}>
                                            Signature Intact:
									</Col>
                                        <Col style={padding} className={rightClass}>
                                            {dataValue(this.props.data.basicSignature.signatureIntact)}
                                        </Col>
                                    </Row>
                                    <Row style={marginRemove}>
                                        <Col style={padding} className={leftClass}>
                                            Signature Valid:
									</Col>
                                        <Col style={padding} className={rightClass}>
                                            {dataValue(this.props.data.basicSignature.signatureValid)}
                                        </Col>
                                    </Row>
                                </Col>
                            }
                        </Row>

                        <Row style={marginRemove}>
                            <Col style={padding} className={leftClass}>Signing Certificate:</Col>
                            {this.props.data.signingCertificate == null ?
                                <Col style={padding} className={rightClass}>-</Col>
                                :
                                <Col className={rightClass} style={noPadding}>
                                    <Row style={marginRemove}>
                                        <Col style={padding} className={leftClass}>
                                            Attribute Present:
									</Col>
                                        <Col style={padding} className={rightClass}>
                                            {dataValue(this.props.data.signingCertificate.attributePresent)}
                                        </Col>
                                    </Row>
                                    <Row style={marginRemove}>
                                        <Col style={padding} className={leftClass}>
                                            Digest Value Present:
									</Col>
                                        <Col style={padding} className={rightClass}>
                                            {dataValue(this.props.data.signingCertificate.digestValuePresent)}
                                        </Col>
                                    </Row>
                                    <Row style={marginRemove}>
                                        <Col style={padding} className={leftClass}>
                                            Digest Value Match:
									</Col>
                                        <Col style={padding} className={rightClass}>
                                            {dataValue(this.props.data.signingCertificate.digestValueMatch)}
                                        </Col>
                                    </Row>
                                    <Row style={marginRemove}>
                                        <Col style={padding} className={leftClass}>
                                            Issuer Serial Match:
									</Col>
                                        <Col style={padding} className={rightClass}>
                                            {dataValue(this.props.data.signingCertificate.issuerSerialMatch)}
                                        </Col>
                                    </Row>
                                    <Row style={marginRemove}>
                                        <Col style={padding} className={leftClass}>
                                            ID:
									</Col>
                                        <Col style={padding} className={rightClass}>
                                            {dataValue(this.props.data.signingCertificate.id)}
                                        </Col>
                                    </Row>
                                </Col>
                            }
                        </Row>

                        <Row style={marginRemove}>
                            <Col style={padding} className={leftClass}>Certificate Chain:</Col>
                            {this.props.data.certificateChain.length == 0 ?
                                <Col style={padding} className={rightClass}>-</Col>
                                :
                                <Col className={rightClass} style={noPadding}>
                                    {this.props.data.certificateChain.map((certificateChain, i) => {
                                        return <React.Fragment key={i}>
                                            <Row style={marginRemove}>
                                                <Col style={padding} className={leftClass}>
                                                    Source:
									</Col>
                                                <Col style={padding} className={rightClass}>
                                                    {dataValue(certificateChain.source)}
                                                </Col>
                                            </Row>
                                            <Row style={marginRemove}>
                                                <Col style={padding} className={leftClass}>
                                                    ID:
									</Col>
                                                <Col style={padding} className={rightClass}>
                                                    {dataValue(certificateChain.id)}
                                                </Col>
                                            </Row>
                                        </React.Fragment>
                                    })}
                                </Col>
                            }
                        </Row>

                        <Row style={marginRemove}>
                            <Col style={padding} className={leftClass}>Trusted:</Col>
                            <Col style={padding} className={rightClass}>{dataValue(this.props.data.trusted)}</Col>
                        </Row>
                        <Row style={marginRemove}>
                            <Col style={padding} className={leftClass}>Self Signed:</Col>
                            <Col style={padding} className={rightClass}>{dataValue(this.props.data.selfSigned)}</Col>
                        </Row>

                        <Row style={marginRemove}>
                            <Col style={padding} className={leftClass}>Certificate Policies:</Col>
                            {this.props.data.certificatePolicies.length == 0 ?
                                <Col style={padding} className={rightClass}>-</Col>
                                :
                                <Col className={rightClass} style={noPadding}>
                                    {this.props.data.certificatePolicies.map((certificatePolicies, i) => {
                                        return <React.Fragment key={i}>
                                            <Row style={marginRemove}>
                                                <Col style={padding} className={leftClass}>
                                                    Value:
									        </Col>
                                                <Col style={padding} className={rightClass}>
                                                    {dataValue(certificatePolicies.value)}
                                                </Col>
                                            </Row>
                                            <Row style={marginRemove}>
                                                <Col style={padding} className={leftClass}>
                                                    Description:
									        </Col>
                                                <Col style={padding} className={rightClass}>
                                                    {dataValue(certificatePolicies.description)}
                                                </Col>
                                            </Row>
                                            <Row style={marginRemove}>
                                                <Col style={padding} className={leftClass}>
                                                    Cps Url:
									        </Col>
                                                <Col style={padding} className={rightClass}>
                                                    {dataValue(certificatePolicies.cpsUrl)}
                                                </Col>
                                            </Row>
                                        </React.Fragment>
                                    })}
                                </Col>
                            }
                        </Row>

                        <Row style={marginRemove}>
                            <Col style={padding} className={leftClass}>Trusted Service Providers:</Col>
                            {this.props.data.trustedServiceProviders.length == 0 ?
                                <Col style={padding} className={rightClass}>-</Col>
                                :
                                <Col className={rightClass} style={noPadding}>
                                    {this.props.data.trustedServiceProviders.map((trustedServiceProviders, i) => {
                                        return <React.Fragment key={i}>
                                            <Row style={marginRemove}>
                                                <Col style={padding} className={leftClass}>
                                                    Country Code:
									            </Col>
                                                <Col style={padding} className={rightClass}>
                                                    {dataValue(trustedServiceProviders.countryCode)}
                                                </Col>
                                            </Row>
                                            <Row style={marginRemove}>
                                                <Col style={padding} className={leftClass}>Trusted Services:</Col>
                                                <Col className={rightClass} style={noPadding}>
                                                    {trustedServiceProviders.trustedServices.map((trustedServices, i) => {
                                                        return <React.Fragment key={i}>
                                                            <Row style={marginRemove}>
                                                                <Col style={padding} className={leftClass}>
                                                                    Service Name:
									                        </Col>
                                                                <Col style={padding} className={rightClass}>
                                                                    {dataValue(trustedServices.serviceName)}
                                                                </Col>
                                                            </Row>
                                                            <Row style={marginRemove}>
                                                                <Col style={padding} className={leftClass}>
                                                                    Service Type:
									                        </Col>
                                                                <Col style={padding} className={rightClass}>
                                                                    {dataValue(trustedServices.serviceType)}
                                                                </Col>
                                                            </Row>
                                                            <Row style={marginRemove}>
                                                                <Col style={padding} className={leftClass}>
                                                                    Status:
									                        </Col>
                                                                <Col style={padding} className={rightClass}>
                                                                    {dataValue(trustedServices.status)}
                                                                </Col>
                                                            </Row>
                                                            <Row style={marginRemove}>
                                                                <Col style={padding} className={leftClass}>
                                                                    Start Date:
									                        </Col>
                                                                <Col style={padding} className={rightClass}>
                                                                    {trustedServices.startDate == null ?
                                                                        "-"
                                                                        :
                                                                        Fecha.format(new Date(trustedServices.startDate), 'DD.MM.YYYY. [at] HH:mm')
                                                                    }
                                                                </Col>
                                                            </Row>
                                                            <Row style={marginRemove}>
                                                                <Col style={padding} className={leftClass}>
                                                                    End Date:
									                        </Col>
                                                                <Col style={padding} className={rightClass}>
                                                                    {trustedServices.endDate == null ?
                                                                        "-"
                                                                        :
                                                                        Fecha.format(new Date(trustedServices.endDate), 'DD.MM.YYYY. [at] HH:mm')
                                                                    }
                                                                </Col>
                                                            </Row>
                                                            <Row style={marginRemove}>
                                                                <Col style={padding} className={leftClass}>Captured Qualifiers:</Col>
                                                                {trustedServices.capturedQualifiers.length == 0 ?
                                                                    <Col style={padding} className={rightClass}>-</Col>
                                                                    :
                                                                    <Col className={rightClass} style={noPadding}>
                                                                        {trustedServices.capturedQualifiers.map((capturedQualifiers, i) => {
                                                                            return <React.Fragment key={i}>
                                                                                <Row style={marginRemove}>
                                                                                    <Col style={padding} className="border">
                                                                                        {dataValue(capturedQualifiers)}
                                                                                    </Col>
                                                                                </Row>
                                                                            </React.Fragment>
                                                                        })}
                                                                    </Col>
                                                                }
                                                            </Row>
                                                            <Row style={marginRemove}>
                                                                <Col style={padding} className={leftClass}>Additional Service Info URIs:</Col>
                                                                {trustedServices.additionalServiceInfoUris.length == 0 ?
                                                                    <Col style={padding} className={rightClass}>-</Col>
                                                                    :
                                                                    <Col className={rightClass} style={noPadding}>
                                                                        {trustedServices.additionalServiceInfoUris.map((additionalServiceInfoUris, i) => {
                                                                            return <React.Fragment key={i}>
                                                                                <Row style={marginRemove}>
                                                                                    <Col style={padding} className="border">
                                                                                        {dataValue(additionalServiceInfoUris)}
                                                                                    </Col>
                                                                                </Row>
                                                                            </React.Fragment>
                                                                        })}
                                                                    </Col>
                                                                }
                                                            </Row>
                                                            <Row style={marginRemove}>
                                                                <Col style={padding} className={leftClass}>Additional Service Info URIs:</Col>
                                                                {trustedServices.serviceSupplyPoints.length == 0 ?
                                                                    <Col style={padding} className={rightClass}>-</Col>
                                                                    :
                                                                    <Col className={rightClass} style={noPadding}>
                                                                        {trustedServices.serviceSupplyPoints.map((serviceSupplyPoints, i) => {
                                                                            return <React.Fragment key={i}>
                                                                                <Row style={marginRemove}>
                                                                                    <Col style={padding} className="border">
                                                                                        {dataValue(serviceSupplyPoints)}
                                                                                    </Col>
                                                                                </Row>
                                                                            </React.Fragment>
                                                                        })}
                                                                    </Col>
                                                                }
                                                            </Row>
                                                            <Row style={marginRemove}>
                                                                <Col style={padding} className={leftClass}>
                                                                    Expired Cert Revocation Info:
									                        </Col>
                                                                <Col style={padding} className={rightClass}>
                                                                    {trustedServices.expiredCertsRevocationInfo == null ?
                                                                        "-"
                                                                        :
                                                                        Fecha.format(new Date(trustedServices.expiredCertsRevocationInfo), 'DD.MM.YYYY. [at] HH:mm')
                                                                    }
                                                                </Col>
                                                            </Row>
                                                        </React.Fragment>
                                                    })}
                                                </Col>
                                            </Row>
                                            <Row style={marginRemove}>
                                                <Col style={padding} className={leftClass}>
                                                    TSP Name:
									                    </Col>
                                                <Col style={padding} className={rightClass}>
                                                    {dataValue(trustedServiceProviders.tspname)}
                                                </Col>
                                            </Row>
                                            <Row style={marginRemove}>
                                                <Col style={padding} className={leftClass}>
                                                    TSP Registration Identifier:
									                    </Col>
                                                <Col style={padding} className={rightClass}>
                                                    {dataValue(trustedServiceProviders.tspregistrationIdentifier)}
                                                </Col>
                                            </Row>
                                        </React.Fragment>
                                    })}
                                </Col>
                            }
                        </Row>
                        <Row style={marginRemove}>
                            <Col style={padding} className={leftClass}>Revocations:</Col>
                            {this.props.data.revocations.length == 0 ?
                                <Col style={padding} className={rightClass}>-</Col>
                                :
                                <Col className={rightClass} style={noPadding}>
                                    {this.props.data.revocations.map((revocations, i) => {
                                        return <React.Fragment key={i}>
                                            <Row style={marginRemove}>
                                                <Col style={padding} className={leftClass}>
                                                    Origin:
									            </Col>
                                                <Col style={padding} className={rightClass}>
                                                    {dataValue(revocations.origin)}
                                                </Col>
                                            </Row>
                                            <Row style={marginRemove}>
                                                <Col style={padding} className={leftClass}>
                                                    Source:
									            </Col>
                                                <Col style={padding} className={rightClass}>
                                                    {dataValue(revocations.source)}
                                                </Col>
                                            </Row>
                                            <Row style={marginRemove}>
                                                <Col style={padding} className={leftClass}>
                                                    Source Address:
                                                    </Col>
                                                <Col style={padding} className={rightClass}>
                                                    {dataValue(revocations.sourceAddress)}
                                                </Col>
                                            </Row>
                                            <Row style={marginRemove}>
                                                <Col style={padding} className={leftClass}>
                                                    Available:
									            </Col>
                                                <Col style={padding} className={rightClass}>
                                                    {dataValue(revocations.available)}
                                                </Col>
                                            </Row>
                                            <Row style={marginRemove}>
                                                <Col style={padding} className={leftClass}>
                                                    Status:
									            </Col>
                                                <Col style={padding} className={rightClass}>
                                                    {dataValue(revocations.status)}
                                                </Col>
                                            </Row>
                                            <Row style={marginRemove}>
                                                <Col style={padding} className={leftClass}>
                                                    Reason:
									            </Col>
                                                <Col style={padding} className={rightClass}>
                                                    {dataValue(revocations.reason)}
                                                </Col>
                                            </Row>
                                            <Row style={marginRemove}>
                                                <Col style={padding} className={leftClass}>
                                                    This Update:
									                        </Col>
                                                <Col style={padding} className={rightClass}>
                                                    {revocations.thisUpdate == null ?
                                                        "-"
                                                        :
                                                        Fecha.format(new Date(revocations.thisUpdate), 'DD.MM.YYYY. [at] HH:mm')
                                                    }
                                                </Col>
                                            </Row>
                                            <Row style={marginRemove}>
                                                <Col style={padding} className={leftClass}>
                                                    Next Update:
									                        </Col>
                                                <Col style={padding} className={rightClass}>
                                                    {revocations.nextUpdate == null ?
                                                        "-"
                                                        :
                                                        Fecha.format(new Date(revocations.nextUpdate), 'DD.MM.YYYY. [at] HH:mm')
                                                    }
                                                </Col>
                                            </Row>
                                            <Row style={marginRemove}>
                                                <Col style={padding} className={leftClass}>
                                                    Revocation Date:
									                        </Col>
                                                <Col style={padding} className={rightClass}>
                                                    {revocations.revocationDate == null ?
                                                        "-"
                                                        :
                                                        Fecha.format(new Date(revocations.revocationDate), 'DD.MM.YYYY. [at] HH:mm')
                                                    }
                                                </Col>
                                            </Row>
                                            <Row style={marginRemove}>
                                                <Col style={padding} className={leftClass}>
                                                    Expired Certs On CRL:
									                        </Col>
                                                <Col style={padding} className={rightClass}>
                                                    {revocations.expiredCertsOnCRL == null ?
                                                        "-"
                                                        :
                                                        Fecha.format(new Date(revocations.expiredCertsOnCRL), 'DD.MM.YYYY. [at] HH:mm')
                                                    }
                                                </Col>
                                            </Row>
                                            <Row style={marginRemove}>
                                                <Col style={padding} className={leftClass}>
                                                    Archive Cut Off:
									                        </Col>
                                                <Col style={padding} className={rightClass}>
                                                    {revocations.archiveCutOff == null ?
                                                        "-"
                                                        :
                                                        Fecha.format(new Date(revocations.archiveCutOff), 'DD.MM.YYYY. [at] HH:mm')
                                                    }
                                                </Col>
                                            </Row>
                                            <Row style={marginRemove}>
                                                <Col style={padding} className={leftClass}>
                                                    Cert Hash Extension Present:
                                                    </Col>
                                                <Col style={padding} className={rightClass}>
                                                    {dataValue(revocations.certHashExtensionPresent)}
                                                </Col>
                                            </Row>
                                            <Row style={marginRemove}>
                                                <Col style={padding} className={leftClass}>
                                                    Cert Hash Extension Match:
                                                    </Col>
                                                <Col style={padding} className={rightClass}>
                                                    {dataValue(revocations.certHashExtensionMatch)}
                                                </Col>
                                            </Row>
                                            <Row style={marginRemove}>
                                                <Col style={padding} className={leftClass}>Digest Algo and Values:</Col>
                                                {revocations.digestAlgoAndValues.length == 0 ?
                                                    <Col style={padding} className={rightClass}>-</Col>
                                                    :
                                                    <Col className={rightClass} style={noPadding}>
                                                        {revocations.digestAlgoAndValues.map((digestAlgoAndValues, i) => {
                                                            return <React.Fragment key={i}>
                                                                <Row style={marginRemove}>
                                                                    <Col style={padding} className={leftClass}>
                                                                        Digest Method:
									                                </Col>
                                                                    <Col style={padding} className={rightClass}>
                                                                        {dataValue(digestAlgoAndValues.digestMethod)}
                                                                    </Col>
                                                                </Row>
                                                                <Row style={marginRemove}>
                                                                    <Col style={padding} className={leftClass}>
                                                                        Digest Value:
									                                </Col>
                                                                    <Col style={padding} className={rightClass}>
                                                                        {dataValue(digestAlgoAndValues.digestValue)}
                                                                    </Col>
                                                                </Row>
                                                            </React.Fragment>
                                                        })}
                                                    </Col>
                                                }
                                            </Row>
                                            <Row style={marginRemove}>
                                                <Col style={padding} className={leftClass}>
                                                    Basic Signature:
                                                </Col>
                                                {revocations.basicSignature == null ?
                                                    <Col style={padding} className={rightClass}>-</Col>
                                                    :
                                                    <Col className={rightClass} style={noPadding}>
                                                        <Row style={marginRemove}>
                                                            <Col style={padding} className={leftClass}>
                                                                Encryption Algo Used To Sign This Token:
									                                </Col>
                                                            <Col style={padding} className={rightClass}>
                                                                {dataValue(revocations.basicSignature.encryptionAlgoUsedToSignThisToken)}
                                                            </Col>
                                                        </Row>
                                                        <Row style={marginRemove}>
                                                            <Col style={padding} className={leftClass}>
                                                                Key Length Used To Sign This Token:
									                                </Col>
                                                            <Col style={padding} className={rightClass}>
                                                                {dataValue(revocations.basicSignature.keyLengthUsedToSignThisToken)}
                                                            </Col>
                                                        </Row>
                                                        <Row style={marginRemove}>
                                                            <Col style={padding} className={leftClass}>
                                                                Digest Algo Used To Sign This Token:
									                                </Col>
                                                            <Col style={padding} className={rightClass}>
                                                                {dataValue(revocations.basicSignature.digestAlgoUsedToSignThisToken)}
                                                            </Col>
                                                        </Row>
                                                        <Row style={marginRemove}>
                                                            <Col style={padding} className={leftClass}>
                                                                Mask Generation Function Used To Sign This Token:
									                                </Col>
                                                            <Col style={padding} className={rightClass}>
                                                                {dataValue(revocations.basicSignature.maskGenerationFunctionUsedToSignThisToken)}
                                                            </Col>
                                                        </Row>
                                                        <Row style={marginRemove}>
                                                            <Col style={padding} className={leftClass}>
                                                                Signature Intact:
									                                </Col>
                                                            <Col style={padding} className={rightClass}>
                                                                {dataValue(revocations.basicSignature.signatureIntact)}
                                                            </Col>
                                                        </Row>
                                                        <Row style={marginRemove}>
                                                            <Col style={padding} className={leftClass}>
                                                                Signature Valid:
									                                </Col>
                                                            <Col style={padding} className={rightClass}>
                                                                {dataValue(revocations.basicSignature.signatureValid)}
                                                            </Col>
                                                        </Row>
                                                    </Col>
                                                }
                                            </Row>
                                            <Row style={marginRemove}>
                                                <Col style={padding} className={leftClass}>
                                                    Signing Certificate:
                                                </Col>
                                                {revocations.signingCertificate == null ?
                                                    <Col style={padding} className={rightClass}>-</Col>
                                                    :
                                                    <Col className={rightClass} style={noPadding}>
                                                        <Row style={marginRemove}>
                                                            <Col style={padding} className={leftClass}>
                                                                Attribute Present:
									                                </Col>
                                                            <Col style={padding} className={rightClass}>
                                                                {dataValue(revocations.signingCertificate.attributePresent)}
                                                            </Col>
                                                        </Row>
                                                        <Row style={marginRemove}>
                                                            <Col style={padding} className={leftClass}>
                                                                Digest Value Present:
									                                </Col>
                                                            <Col style={padding} className={rightClass}>
                                                                {dataValue(revocations.signingCertificate.digestValuePresent)}
                                                            </Col>
                                                        </Row>
                                                        <Row style={marginRemove}>
                                                            <Col style={padding} className={leftClass}>
                                                                Digest Value Match:
									                                </Col>
                                                            <Col style={padding} className={rightClass}>
                                                                {dataValue(revocations.signingCertificate.digestValueMatch)}
                                                            </Col>
                                                        </Row>
                                                        <Row style={marginRemove}>
                                                            <Col style={padding} className={leftClass}>
                                                                Issuer Serial Match:
									                                </Col>
                                                            <Col style={padding} className={rightClass}>
                                                                {dataValue(revocations.signingCertificate.issuerSerialMatch)}
                                                            </Col>
                                                        </Row>
                                                        <Row style={marginRemove}>
                                                            <Col style={padding} className={leftClass}>
                                                                ID:
									                                </Col>
                                                            <Col style={padding} className={rightClass}>
                                                                {dataValue(revocations.signingCertificate.id)}
                                                            </Col>
                                                        </Row>
                                                    </Col>
                                                }
                                            </Row>
                                            <Row style={marginRemove}>
                                                <Col style={padding} className={leftClass}>Certificate Chain:</Col>
                                                {revocations.certificateChain.length == 0 ?
                                                    <Col style={padding} className={rightClass}>-</Col>
                                                    :
                                                    <Col className={rightClass} style={noPadding}>
                                                        {revocations.certificateChain.map((certificateChain, i) => {
                                                            return <React.Fragment key={i}>
                                                                <Row style={marginRemove}>
                                                                    <Col style={padding} className={leftClass}>
                                                                        Source:
									                                </Col>
                                                                    <Col style={padding} className={rightClass}>
                                                                        {dataValue(certificateChain.source)}
                                                                    </Col>
                                                                </Row>
                                                                <Row style={marginRemove}>
                                                                    <Col style={padding} className={leftClass}>
                                                                        ID:
									                                </Col>
                                                                    <Col style={padding} className={rightClass}>
                                                                        {dataValue(certificateChain.id)}
                                                                    </Col>
                                                                </Row>
                                                            </React.Fragment>
                                                        })}
                                                    </Col>
                                                }
                                            </Row>
                                            <Row style={marginRemove}>
                                                <Col style={padding} className={leftClass}>
                                                    Base 64 Encoded:
                                                </Col>
                                                <Col style={padding} className={rightClass}>
                                                    {dataValue(revocations.base64Encoded)}
                                                </Col>
                                            </Row>
                                            <Row style={marginRemove}>
                                                <Col style={padding} className={leftClass}>
                                                    ID:
                                                </Col>
                                                <Col style={padding} className={rightClass}>
                                                    {dataValue(revocations.id)}
                                                </Col>
                                            </Row>

                                        </React.Fragment>
                                    })}
                                </Col>
                            }
                        </Row>
                        <Row style={marginRemove}>
                            <Col style={padding} className={leftClass}>
                                Base 64 Encoded:
                            </Col>
                            <Col style={padding} className={rightClass}>
                                {dataValue(this.props.data.base64Encoded)}
                            </Col>
                        </Row>
                        <Row style={marginRemove}>
                            <Col style={padding} className={leftClass}>OCSP access URLs:</Col>
                            {this.props.data.ocspaccessUrls.length == 0 ?
                                <Col style={padding} className={rightClass}>-</Col>
                                :
                                <Col className={rightClass} style={noPadding}>
                                    {this.props.data.ocspaccessUrls.map((ocspaccessUrls, i) => {
                                        return <React.Fragment key={i}>
                                            <Row style={marginRemove}>
                                                <Col style={padding} className="border">
                                                    {dataValue(ocspaccessUrls)}
                                                </Col>
                                            </Row>
                                        </React.Fragment>
                                    })}
                                </Col>
                            }
                        </Row>
                        <Row style={marginRemove}>
                            <Col style={padding} className={leftClass}>QC Types:</Col>
                            {this.props.data.qctypes.length == 0 ?
                                <Col style={padding} className={rightClass}>-</Col>
                                :
                                <Col className={rightClass} style={noPadding}>
                                    {this.props.data.qctypes.map((qctypes, i) => {
                                        return <React.Fragment key={i}>
                                            <Row style={marginRemove}>
                                                <Col style={padding} className={leftClass}>
                                                    Value:
									            </Col>
                                                <Col style={padding} className={rightClass}>
                                                    {dataValue(qctypes.value)}
                                                </Col>
                                            </Row>
                                            <Row style={marginRemove}>
                                                <Col style={padding} className={leftClass}>
                                                    Description:
									            </Col>
                                                <Col style={padding} className={rightClass}>
                                                    {dataValue(qctypes.description)}
                                                </Col>
                                            </Row>
                                        </React.Fragment>
                                    })}
                                </Col>
                            }
                        </Row>
                        <Row style={marginRemove}>
                            <Col style={padding} className={leftClass}>CRL Distribution Points:</Col>
                            {this.props.data.crldistributionPoints.length == 0 ?
                                <Col style={padding} className={rightClass}>-</Col>
                                :
                                <Col className={rightClass} style={noPadding}>
                                    {this.props.data.crldistributionPoints.map((crldistributionPoints, i) => {
                                        return <React.Fragment key={i}>
                                            <Row style={marginRemove}>
                                                <Col style={padding} className="border">
                                                    {dataValue(crldistributionPoints)}
                                                </Col>
                                            </Row>
                                        </React.Fragment>
                                    })}
                                </Col>
                            }
                        </Row>
                        <Row style={marginRemove}>
                            <Col style={padding} className={leftClass}>QC Statement IDs:</Col>
                            {this.props.data.qcstatementIds.length == 0 ?
                                <Col style={padding} className={rightClass}>-</Col>
                                :
                                <Col className={rightClass} style={noPadding}>
                                    {this.props.data.qcstatementIds.map((qcstatementIds, i) => {
                                        return <React.Fragment key={i}>
                                            <Row style={marginRemove}>
                                                <Col style={padding} className={leftClass}>
                                                    Value:
									            </Col>
                                                <Col style={padding} className={rightClass}>
                                                    {dataValue(qcstatementIds.value)}
                                                </Col>
                                            </Row>
                                            <Row style={marginRemove}>
                                                <Col style={padding} className={leftClass}>
                                                    Description:
									            </Col>
                                                <Col style={padding} className={rightClass}>
                                                    {dataValue(qcstatementIds.description)}
                                                </Col>
                                            </Row>
                                        </React.Fragment>
                                    })}
                                </Col>
                            }
                        </Row>
                    </div>
                </Collapse>
            </React.Fragment >
        );
    }
}

function dataValue(value) {
    return <React.Fragment>
        {value == null ?
            "-"
            :
            <React.Fragment>{'' + value}</React.Fragment>
        }
    </React.Fragment>
}